import React from 'react';
import { Box } from '@chakra-ui/react';
import UploadFile from './UploadFile';

function index() {
  return (
    <>
      {/* <Box borderRadius={"30px"} border={"1px solid red"}> */}
        <UploadFile />
      {/* </Box> */}
    </>
  );
}

export default index;
